<script>
    import { writable } from "svelte/store";
    import Feature from "../Branding/Feature";
    import User from "../Branding/User";
    import AircraftProperty from "../Models/Enums/AircraftProperty";
    import VesselGroup from "../Models/VesselGroup";
    import MySvelteTable from "../UI/AlertList/MySvelteTable.svelte";   

	import "../UI/AlertList/AlertList.scss";

    export let aircrafts = writable([]);
    export let aircraftGroup = new VesselGroup();
	export let height = "auto";

    let resultsTableColumns = [
		{
			key: "icaoAddress",
			title: "ICAO Address",
			value: v => v.icaoAddress,
			sortable: true,
			renderValue: (v, v2) => {
				return v.icaoAddress;
			},
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "imo"
		},
		{
			key: "flightNumber",
			title: "Flight No.",
			value: v => v.flightNumber,
			sortable: true,
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "mmsi"
		},
        {
			key: "registration",
			title: "Registration",
			value: v => v.registration,
			sortable: true,
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "imo"
		},
		{
			key: "callSign",
			title: "Call Sign",
			value: v => v.callSign,
			sortable: true,
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "imo"
		}
    ];

	let lastUpdated = aircraftGroup.lastUpdated;
    let resultsTableRowsFiltered = writable([]);
	$: {
		$lastUpdated;
		$resultsTableRowsFiltered = $aircrafts.map((row) => {
			return {
				icaoAddress: row.icaoAddress,
				flightNumber: row.flightNumber,
				callSign: row.callSign,
				registration: row.registration,
				selected: row.selected
			};
		});
		console.log("resultsTableRowsFiltered", resultsTableRowsFiltered);
	}

	let onCellClick = event => {
		const columnKey = event.detail.key;
		const rowData = event.detail.row;

		const icaoAddress = rowData.icaoAddress;
		
		if (User.hasFeature(Feature.VESSEL_HISTORY.INVESTIGATE)) {
			const aircraft = aircraftGroup.find({[AircraftProperty.ICAO_ADDRESS]: icaoAddress});
			//console.log('cell click, vessel', vessel);
			if (aircraft) {
				aircraft.selected = !aircraft.selected;
				aircraftGroup.update();
			}
		}
	};

</script>

<div class="selection-list-element">
    <div class="alert-list-content mdc-elevation--z2" style={"height:" + height + ";"}>
        <MySvelteTable
            on:clickCell={onCellClick}
            rows={$resultsTableRowsFiltered}
            columns={resultsTableColumns} />
    </div>
</div>